<section class="hero" [style.background-image]="'url(' + heroBackground + ')'">
  <div class="hero__inner container-fluid">
    <div class="row align-items-end pb-5">
      <div class="col-12 col-lg-8 col-md-8">
        <div class="hero__text">
          <h1 class="hf f80">
            <span class="hf f180">WELCOME TO XDGE</span>
            <small class="f120">HOW EXTREME ARE YOU?</small>
          </h1>
          <p class="hero__lede f18">
            XDGE is the first platform to unify extreme sports through a shared risk-based system. We are built for athletes who compete across the
            four elements: Air, Earth, Water, and Ice. We track progress, reward risk, and connect athletes through earned experiences. No shortcuts.
            No buying in. No pretending.
          </p>
          <div class="hero__actions">
            <button class="hero-btn primary text-uppercase f16" type="button">Evaluate my level</button>
            <button class="hero-btn ghost text-uppercase f16" type="button">Explore sports</button>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 col-md-4 text-center">
        <div class="hero__feature video-card">
          <button class="video-thumbnail" type="button" (click)="openHeroVideo()">
            <img [src]="heroVideoThumbnail" [alt]="heroVideoTagline" loading="lazy" />
            <span class="play-button" aria-hidden="true">
              <span class="play-icon"></span>
            </span>
            <span class="play-label hf text-uppercase">{{ heroVideoTagline }}</span>
          </button>
          <div class="hero__feature-copy">
            <p>{{ heroVideoTagline }}</p>
          </div>
        </div>

        <div class="hero__stats mt-4 mt-lg-5">
          <div class="stat">
            <span class="value f40">04</span>
            <span class="label f16">Sport elements</span>
          </div>
          <div class="stat">
            <span class="value f40">60+</span>
            <span class="label f16">Sports tracked</span>
          </div>
          <div class="stat">
            <span class="value f80" style="line-height: 0.4">∞</span>
            <span class="label f16">Levels to climb</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #heroVideoModal>
    <div class="hero-video-modal">
      <button type="button" class="hero-video-close" aria-label="Close video" (click)="closeHeroVideo()">&times;</button>
      <video #heroVideo class="hero-video-player" controls playsinline [attr.poster]="heroVideoPoster">
        <source [attr.src]="heroVideoSource" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </ng-template>
</section>
